/* eslint-disable max-lines */
import { enTheme, IThemeCustomizerModel } from 'interfaces/theme';

export function GetDefaultTheme(themeId: enTheme): IThemeCustomizerModel {
  if (themeId === enTheme.HOTSITE) {
    return {
      bannerCenter: '',
      bannerTop: '',
      bannerRight: '',
      bannerYoutube: '',
      labels: {
        font: {
          color: '#232323'
        }
      },
      inputs: {
        bgcolor: '#FFFFFF',
        font: {
          color: '#555555'
        },
        border: {
          color: '#CCCCCC',
          size: 1,
          style: 'solid'
        }
      },
      background: {
        color: '#898989',
        image: ''
      },
      buttons: {
        bgcolor: '#ACACAC',
        text: '',
        bgcolorhover: '#929292',
        font: {
          color: '#FFFFFF'
        }
      },
      header: {
        bgcolor: '#565656',
        font: {
          color: '#FFFFFF'
        }
      },
      footer: {
        font: {
          color: '#FFFFFF'
        }
      },
      languageBar: {
        bgColor: 'rgba(255, 255, 255, 1)',
        font: {
          color: '#000000'
        }
      },
      toastMessages: {
        bgColor: '#FFFFFF',
        font: {
          color: '#596375'
        },
        animationType: ''
      },
      shortageTimer: {
        isActive: false,
        bgColor: 'rgba(255, 152, 0, .8)',
        font: {
          color: '#FFFFFF'
        },
        message: 'Estou aguardando sua confirmação... Não perca essa oportunidade!',
        countTime: 15
      },
      template: '14'
    };
  }

  if (themeId === enTheme.PADRAO) {
    return {
      bannerCenter: '',
      bannerTop: '',
      bannerRight: '',
      bannerYoutube: '',
      labels: {
        font: {
          color: '#555555'
        }
      },
      inputs: {
        bgcolor: '#FFFFFF',
        font: {
          color: '#555555'
        },
        border: {
          color: '#CCCCCC',
          size: 1,
          style: 'solid'
        }
      },
      background: {
        color: '',
        image: ''
      },
      buttons: {
        bgcolor: '#2EAD43',
        text: '',
        bgcolorhover: '#238533',
        font: {
          color: '#FFFFFF'
        }
      },
      header: {
        bgcolor: '',
        font: {
          color: ''
        }
      },
      footer: {
        font: {
          color: ''
        }
      },
      languageBar: {
        bgColor: 'rgba(255, 255, 255, 1)',
        font: {
          color: '#000000'
        }
      },
      toastMessages: {
        bgColor: '#FFFFFF',
        font: {
          color: '#596375'
        },
        animationType: ''
      },
      shortageTimer: {
        isActive: false,
        bgColor: 'rgba(255, 152, 0, .8)',
        font: {
          color: '#FFFFFF'
        },
        message: 'Estou aguardando sua confirmação... Não perca essa oportunidade!',
        countTime: 15
      },
      template: '18'
    };
  }

  if (themeId === enTheme.WIDGET) {
    return {
      bannerCenter: '',
      bannerTop: '',
      bannerRight: '',
      labels: {
        font: {
          color: '#636871'
        }
      },
      inputs: {
        bgcolor: '#FFFFFF',
        font: {
          color: '#555555'
        },
        border: {
          color: '#CCCCCC',
          size: 1,
          style: 'solid'
        }
      },
      background: {
        color: '#CDCFD3',
        image: ''
      },
      buttons: {
        bgcolor: '#3960A3',
        text: '',
        bgcolorhover: '#2C4A7D',
        font: {
          color: '#FFFFFF'
        }
      },
      header: {
        bgcolor: '#CDCFD3',
        font: {
          color: '#FFFFFF'
        }
      },
      footer: {
        font: {
          color: '#FFFFFF'
        }
      },
      languageBar: {
        bgColor: 'rgba(255, 255, 255, 1)',
        font: {
          color: '#000000'
        }
      },
      toastMessages: {
        bgColor: '#FFFFFF',
        font: {
          color: '#596375'
        }
      },
      template: '16'
    };
  }

  return {};
}

export function GetThemeOptions(themeId: number) {
  if (themeId === enTheme.HOTSITE) {
    return {
      id: 14,
      name: 'Hotsite',
      icon: 'hotsite',
      options: [
        {
          id: 'principalMedia',
          title: 'Mídia Principal',
          description: 'É a mídia de maior destaque nesse template.',
          icon: 'hotsitePrincipalMedia'
        },
        {
          id: 'background',
          title: 'Plano de Fundo',
          description: 'Personalize o plano de fundo do seu tema.',
          icon: 'hotsiteBackground'
        },
        {
          id: 'form',
          title: 'Formulário',
          description: 'Personalize o estilo do formulário de compra do tema.',
          icon: 'hotsiteForm'
        },
        {
          id: 'actionButton',
          title: 'Botão de Ação',
          description: 'Configure o estilo e texto do botão de ação.',
          icon: 'buyButton'
        },
        {
          id: 'languageBar',
          title: 'Barra de Idiomas',
          description: 'Personalize as propriedades da barra de idioma',
          icon: 'languageSelectBar'
        },
        {
          id: 'toastMessages',
          title: 'Toast Messages',
          description: 'Adicione as características do seu produto nas notificações.',
          icon: 'toastMessages'
        },
        {
          id: 'shortageTimer',
          title: 'Timer de Escassez',
          description: 'Adicione uma contagem regressiva para incentivar a compra.',
          icon: 'shortageTimer'
        }
      ]
    };
  }

  if (themeId === enTheme.WIDGET) {
    return {
      id: 16,
      name: 'Widget',
      icon: 'widget',
      options: [
        {
          id: 'widgetPrincipalMedia',
          title: 'Mídia Principal',
          description: 'Selecione uma imagem ou uma cor para o seu plano de fundo.',
          icon: 'widgetPrincipalMedia'
        },
        {
          id: 'form',
          title: 'Formulário',
          description: 'Personalize o estilo do formulário de compra do tema.',
          icon: 'widgetForm'
        },
        {
          id: 'actionButton',
          title: 'Botão de Ação',
          description: 'Configure o estilo e texto do botão de ação.',
          icon: 'buyButton'
        },
        {
          id: 'toastMessages',
          title: 'Toast Messages',
          description: 'Adicione as características do seu produto nas notificações.',
          icon: 'toastMessages'
        }
      ]
    };
  }

  return {
    id: 18,
    name: 'Padrão',
    icon: 'padrao',
    options: [
      {
        id: 'topBanner',
        title: 'Banner Superior',
        description: 'É a mídia de maior destaque nesse template.',
        icon: 'padraoPrincipalMedia'
      },
      {
        id: 'sideBanner',
        title: 'Banner Lateral',
        description: 'É a mídia de maior destaque nesse template.',
        icon: 'padraoSideBanner'
      },
      {
        id: 'form',
        title: 'Formulário',
        description: 'Personalize o estilo do formulário de compra do tema.',
        icon: 'padraoForm'
      },
      {
        id: 'actionButton',
        title: 'Botão de Ação',
        description: 'Configure o estilo e texto do botão de ação.',
        icon: 'buyButton'
      },
      {
        id: 'languageBar',
        title: 'Barra de Idiomas',
        description: 'Personalize as propriedades da barra de idioma',
        icon: 'padraoLanguageSelectBar'
      },
      {
        id: 'toastMessages',
        title: 'Toast Messages',
        description: 'Adicione as características do seu produto nas notificações.',
        icon: 'toastMessages'
      },
      {
        id: 'shortageTimer',
        title: 'Timer de Escassez',
        description: 'Adicione uma contagem regressiva para incentivar a compra.',
        icon: 'shortageTimer'
      }
    ]
  }; // tslint:disable-next-line:max-file-line-count
}
